import { render } from "./Feeds.vue?vue&type=template&id=7bcaaa5e&scoped=true"
import script from "./Feeds.vue?vue&type=script&lang=js"
export * from "./Feeds.vue?vue&type=script&lang=js"

import "./Feeds.vue?vue&type=style&index=0&id=7bcaaa5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bcaaa5e"]])

export default __exports__